import React, { useEffect } from "react";
import { Grid, Typography } from "@mui/material";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { tabselected } from "../../consts.js";
import ConversationInsight from "./conversation-insight";
import ConversationTranscript from "./conversation-transcript";
import { useThemeMode } from "../../components/theme/index.jsx";
import S3_Util from "../../utils/s3-folder-creation/s3-folder-utilty.js";

function Conversation() {
    const navigate = useNavigate();
    const location = useLocation();

    const { colours, FONT } = useThemeMode();

    const [params] = useSearchParams();
    const [conversationId, setConversationId] = React.useState(params.get("id") || "");
    const [selectedTab, setSelectedTab] = React.useState("Conversation insight");

    useEffect(() => {
        if (!conversationId) {
            returnToCampaigns();
        }
        const getConversationFromS3 = async () => {
            const audioTranscripts = await S3_Util.getS3File("transcripts/" + conversationId + ".json");
            console.log("audioTranscripts = ", audioTranscripts);
        }
        /**
         * Disabled for now as we are not using this S3 file
         */
        // getConversationFromS3();
    }, [conversationId]);

    // on location search update get the new conversation ny id
    useEffect(() => {
        setSelectedTab("Conversation insight");
        if (conversationId !== params.get("id")) {
            setConversationId(params.get("id"));
        }
    }, [location.search]);

    const returnToCampaigns = () => {
        navigate("/campaigns");
    }

    return (
        <Grid display="flex" flexDirection="column" flexGrow="1" overflow="auto">
            <Grid
                display="flex"
                flexDirection="row"
                flexWrap="wrap"
                borderBottom={colours.dividergraybottomborder}
                paddingX={1}
                alignItems="center"
                gap={1}
            >
                <Typography
                    component="div"
                    display="flex"
                    flexDirection="row"
                    marginRight="auto"
                    alignItems={{ xs: 'end', sm: 'normal' }}
                >
                    <Typography component="div"
                        sx={tabselected(selectedTab === "Conversation insight", colours, FONT)}
                        onClick={() => setSelectedTab("Conversation insight")}
                    >
                        Conversation Insight
                    </Typography>
                    <Typography component="div"
                        sx={tabselected(selectedTab === "Transcript", colours, FONT)}
                        onClick={() => setSelectedTab("Transcript")}
                    >
                        Transcript
                    </Typography>
                </Typography>
                {/* <Typography component="div" sx={{ order: { xs: '-1', sm: '0' }, paddingTop: { xs: 1, sm: 0 } }}>
                    <Button
                        variant="contained"
                        onClick={() => {}}
                        startIcon={<FeatherIcon icon="upload" size={20} />}
                    >
                        Upload
                    </Button>
                </Typography> */}
            </Grid>

            {selectedTab === "Conversation insight" ? <ConversationInsight conversationId={conversationId} /> : null}
            {selectedTab === "Transcript" ? <ConversationTranscript conversationId={conversationId} /> : null}
        </Grid>
    );
}

export default Conversation;
